import { unreadCountMessagesSelector } from 'store/selectors/messagesSelectors';
import { userSettingsSelector } from 'store/selectors/userSelectors';
import { useTypedSelector } from 'hooks/useTypedSelector';
import { ACCOUNT_SUPPLIER } from 'components/Settings/constants';
import { ERouteNames, ERoutePaths } from 'types/routes/enums';
import { EAccountStatuses } from 'types/userTypes';
import { DollarIcn, HomeIcn, MailIcn, OrderIcn, ProductIcn, SettingsIcn } from 'utils/icons';

export interface ILeftPanelMenu {
  name: ERouteNames,
  icon: any,
  path: string,
  count?: number,
}

export default function() {
  const unreadMessageCount = useTypedSelector(unreadCountMessagesSelector);
  const { approvalStatus } = useTypedSelector(userSettingsSelector);

  const leftPanelTopMenu: ILeftPanelMenu[] = [
    { name: ERouteNames.Home, icon: HomeIcn, path: ERoutePaths.Home },
    // { name: ERouteNames.Dashboard, icon: DashboardIcn, path: ERoutePaths.Dashboard },
    { name: ERouteNames.Products, icon: ProductIcn, path: ERoutePaths.Products },
    { name: ERouteNames.Orders, icon: OrderIcn, path: ERoutePaths.Orders },
    ...(approvalStatus === EAccountStatuses.Approved ? [
      { name: ERouteNames.Messages, icon: MailIcn, path: ERoutePaths.Messages, count: unreadMessageCount },
    ] : []),
    { name: ERouteNames.Payments, icon: DollarIcn, path: ERoutePaths.Payments },
  ];

  const leftPanelBottomMenu: ILeftPanelMenu[] = [
    { name: ERouteNames.Settings, icon: SettingsIcn, path: `${ERoutePaths.Settings}?tab=${ACCOUNT_SUPPLIER}` },
  ];

  return { menus: [leftPanelTopMenu, leftPanelBottomMenu] };
}
